<template>
  <div class="flex flex-no-wrap flex-row justify-start users-details">
    <div class="user-image" v-lazy-container="{ selector: 'img', error: setImageUrl('default.png')}">
      <img :data-src="details.image" class="w-full" >
    </div>
    <p class="leading-none text-gray-600 font-light">{{details.full_name}} <br>
      <span class="text-xs text-gray-300">{{dateFormat(details.created_at)}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'customer',
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.users-details {
  flex: 0 1 70%;
  p {
    padding-top: 9px;
    font-size: 14px;
    padding-left: 10px;
  }
  .user-image {
    flex: 0 1 8%;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
}
</style>
